import axios from "axios";
import { getBackendUrl } from "../config";
import { getFrontendBackendBaseUrl, normalizeUrlsDeep } from "../helpers/normalizeUrls";

const baseURL = getBackendUrl() || process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
	baseURL,
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL,
});

function attachUrlNormalizer(client) {
	client.interceptors.response.use(
		(response) => {
			// Don't touch binary responses
			const responseType = response?.config?.responseType;
			if (responseType === "arraybuffer" || responseType === "blob") return response;

			const backendBase = getFrontendBackendBaseUrl();
			if (response?.data) {
				normalizeUrlsDeep(response.data, backendBase);
			}
			return response;
		},
		(error) => {
			const status = error?.response?.status;
			const method = String(error?.config?.method || "GET").toUpperCase();
			const requestUrl = error?.config?.url;
			if (status && requestUrl && typeof error?.message === "string" && !error.message.includes(requestUrl)) {
				error.message = `${error.message} [${method} ${requestUrl}]`;
			}
			return Promise.reject(error);
		}
	);
}

attachUrlNormalizer(api);
attachUrlNormalizer(openApi);

export default api;
